




















import {Vue, Component, Prop } from 'vue-property-decorator';
import * as api from '@/store/api'
import * as letterOwnerService from '@/store/Services/letterOwnerService';
import {PhoneBook} from '@/store/models/LetterOwner/PhoneBook';
import store from '@/store';
import { CompanyBranch } from '@/store/models/CompanyBranch/CompanyBranch';




@Component({
})
export default class CategoryGroupPhonebookMobile extends Vue {
    id= '';
    @Prop() companyId?: string;
    @Prop() data?: PhoneBook[];
     @Prop() AllBranch?: CompanyBranch[]
    shallShowOutterCompanyContact=false

     get filterdData(){
         
        //  const noDuplicationData=this.data?.filter((thing, i, arr) => arr.findIndex(t => t.id === thing.id) === i);
         if(this.companyId!=null)
            return this.data?.filter(x=>x.companyId==this.companyId && (x.companyName || x.companyBranchName));
        else
            return this.data?.filter(x=>x.companyId==null && (x.firstName || x.lastName));
     }

     get filterCompanyById(){
         if(this.companyId!=null)
            return this.data?.filter(x=>x.companyId==this.companyId)[0].companyName;
        else
            return null;
     }
        onShow(id: string,companyId: string,type: number,companyBranchName: string){
            if(companyId!=null){
                if(type==2){
                    const companyRoot=this.AllBranch?.filter(x=>x.companyId==companyId);
                    if(companyRoot!=null || companyRoot!=undefined){
                        if(companyBranchName.trim()=='کارخانه'){
                            const factoryId=companyRoot.filter(x=>x.name.trim()=="کارخانه")[0].id;
                            store.state.eventHub.$emit('loadCompanyBranchContactInfo',factoryId)
                        }else{
                            const mainCenterCompanyId=companyRoot.filter(x=>(x.name.trim()=="دفتر مرکزی" || x.name.trim()=="دفترمرکزی"))[0].id;
                            store.state.eventHub.$emit('loadCompanyBranchContactInfo',mainCenterCompanyId)
                        }
                    }
                }else{
                    store.state.eventHub.$emit('loadCompanyPersonel',id)
                }
                this.shallShowOutterCompanyContact=true;
            }else{
                store.state.eventHub.$emit('loadPersonelDetails',id)
            }
        }
}

